<template>
  <div>
    <Hero
      subheadline="Nicht zu Hause und doch Daheim..."
      headline="Haus Morgensonne"
      :src="items.house[1].src"
    />
    <section class="wrapper mt-8 sm:mt-20">
      <h1 class="sm:text-center font-serif">Das Wohnhaus</h1>
      <p class="font-semibold text-gray-700 leading-relaxed text-xl mt-4">
        Das von uns 1986 erbaute Wohnhaus wurde ausschließlich mit Fichten und
        Tannenholz aus heimischen Wäldern erstellt. Auf unserer alten Dorfsäge,
        wurden die Baumstämme zu Bauholz gesägt und anschließend auf dem
        Sägeplatz nach alter Zimmermannstradition abgebunden.
      </p>
    </section>
    <section role="main" class="max-w-4xl px-4 mx-auto mt-6">
      <p class="mt-2">
        Wir lieben unsere Heimat und die frische Schwarzwaldluft. Aus diesem
        Grund haben wir uns 2002 entschlossen auf unserem Süddach eine
        Photovoltaikanlage zur Stromgewinnung, sowie eine Thermosolaranlage zur
        Warmwasseraufbereitung und Heizungsunterstützung in den Übergangsmonaten
        zu installieren.
      </p>
      <p class="mt-2">
        So können wir einen großen Teil unseres Strombedarfs selbst produzieren.
        Bei der Warmwasseraufbereitung sowie der Heizungsunterstützung haben wir
        zusammen mit dem Kachelofen ebenfalls einen hohen Deckungsgrad. Mit
        sorgfältig ausgesuchten Baumaterialen konnten wir in unserem
        Schwarzwaldhaus ein angenehmes Wohnklima schaffen.
      </p>
    </section>
    <section class="bg-gray-100 mt-12 sm:mt-24 py-8 sm:pt-16 sm:pb-40">
      <div class="max-w-6xl px-2 mx-auto">
        <h2 class="text-center">Bilder</h2>
        <ImageGallery class="mt-4 sm:mt-12" :images="items.house" />
      </div>
    </section>
  </div>
</template>

<script>
import ImageGallery from '../components/ImageGallery.vue'
import Hero from '../components/Hero.vue'
import currentSeason from '../services/getSeason'
import Quote from '../components/Quote.vue'

export default {
  name: 'House',
  components: { ImageGallery, Hero, Quote },
  methods: {
    handleScroll(event) {
      if (window.scrollY > 0) {
        this.setDarkNav()
      } else {
        this.setWhiteNav()
      }
    },
    setDarkNav() {
      this.$store.dispatch('setDarkNav')
    },
    setWhiteNav() {
      this.$store.dispatch('setWhiteNav')
    },
  },
  mounted() {
    this.setWhiteNav()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    this.setDarkNav()
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      name: 'This is the Imagegallery component',
      quotes: {
        first: {
          text: 'Die Welt gehört dem, der sie genießt.',
          author: 'G.Leopardi',
        },
      },
      items: {
        house: [
          // {
          //   src: 'img/haus/drohnenaufnahme.jpg',
          //   w: 1440,
          //   h: 810,
          //   thumbnail: 'img/haus/drohnenaufnahme.jpg',
          // },
          {
            src: 'img/haus/hero_image.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/haus/thumb/hero_image.jpeg',
          },
          {
            src: 'img/haus/_85C9083.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/haus/thumb/_85C9083.jpeg',
          },
          {
            src: 'img/haus/IMG_8431.jpeg',
            w: 1920,
            h: 1440,
            thumbnail: 'img/haus/thumb/IMG_8431.jpeg',
          },
          {
            src: 'img/haus/IMG_4097.jpeg',
            w: 1920,
            h: 1440,
            thumbnail: 'img/haus/thumb/IMG_4097.jpeg',
          },
          {
            src: 'img/haus/136A9440.jpg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/haus/thumb/136A9440.jpg',
          },
          {
            src: 'img/haus/_85C9093.jpeg',
            w: 1920,
            h: 1280,
            thumbnail: 'img/haus/thumb/_85C9093.jpeg',
          },
        ],
      },
    }
  },
  computed: {
    summerSeason() {
      let seasonState = true
      const season = currentSeason()

      if (season === 'winter') {
        seasonState = false
      }
      return seasonState
    },
  },
}
</script>
